import { render, staticRenderFns } from "./CircleChat.vue?vue&type=template&id=53817f5e&scoped=true"
import script from "./CircleChat.vue?vue&type=script&lang=js"
export * from "./CircleChat.vue?vue&type=script&lang=js"
import style0 from "./CircleChat.vue?vue&type=style&index=0&id=53817f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53817f5e",
  null
  
)

export default component.exports